import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';

import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function PartnerModal({
  createInput,
  createTextArea,
  createInputNumber,
  createUserManagement,
  formData,
  getSettings,
  history,
  showUserManagement,
  getRoleList,
  creating,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    createUserManagement(formData, ({ data }) => {
      setModal({ isOpen: false });
      getSettings();
      history.push(
        `/ordinance-violation-receipts/settings/violation-fees/${_.get(
          data,
          'id'
        )}`
      );
      showUserManagement(data.id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    getRoleList();
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'violation_code', label: 'Violation Code' },
              { required: true, placeholder: 'Input violation code' }
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'reference', label: 'Reference' },
              { required: true, placeholder: 'Input reference' }
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-12 form-group">
            {createTextArea(
              { key: 'particular', label: 'Particular' },
              { required: true, placeholder: 'Input particulars' }
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-12 form-group">
            {createInputNumber(
              { key: 'fine', label: 'Fine Amount' },
              { required: true, placeholder: 'Input fine amount' }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

PartnerModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  createTextArea: PropTypes.instanceOf(Function).isRequired,
  createInputNumber: PropTypes.instanceOf(Function).isRequired,
  getSettings: PropTypes.instanceOf(Function).isRequired,
  createUserManagement: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  showUserManagement: PropTypes.instanceOf(Function).isRequired,
  getRoleList: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  roleList: _.get(api, `${c.GET_ROLE_LIST}.list`) || [],
  creating: api.loading.indexOf(c.CREATE_SETTING) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(PartnerModal);
